import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useFasteningChoicesApi } from "../../../../../http/border/useFasteningChoices";
import FasteningChoiceForm from "./FasteningChoiceForm";

interface EditFasteningChoiceProps {
  fasteningChoiceId: string;
  onClose: () => void;
  systemId: string;
}

const EditFasteningChoice: FC<EditFasteningChoiceProps> = ({ fasteningChoiceId, onClose, systemId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const fasteningChoicesApi = useFasteningChoicesApi();

  const { data, error, trigger } = fasteningChoicesApi.getAdminFasteningChoice(
    fasteningChoiceId,
    aborter.current.signal,
  );

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    fasteningChoiceId && trigger();
  }, [fasteningChoiceId]);

  return (
    <FasteningChoiceForm
      onClose={onClose}
      fasteningChoice={data}
      systemId={systemId}
      isDisabled={!!error}
      isLoading={!data && !error}
    />
  );
};

export default EditFasteningChoice;
